// extracted by mini-css-extract-plugin
module.exports = {"link":"basket-link--13291","link__bp":"basket-link__bp--54b7f"};